export function common() {
  const header = document.getElementById("js-header");

  // ヘッダーのスクロール処理
  const headerScroll = () => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 1 && window.innerWidth > 768) {
        header.classList.add("is-scroll");
      } else {
        header.classList.remove("is-scroll");
      }
    });
  };

  headerScroll();

  // ローディングアニメーションの初期化
  const initializeLoadingAnimation = () => {
    // ローディング要素が存在するかどうかで判定（より確実）
    const loadingContainer = document.querySelector(".c-loading");
    if (!loadingContainer) return; // ローディング要素が存在しない場合は処理をスキップ

    // GSAPが読み込まれているか確認
    if (typeof gsap === "undefined") {
      console.error("GSAP is not loaded");
      // GSAPが読み込まれていない場合でも画面操作を可能にする
      loadingContainer.style.display = "none";
      return;
    }

    const loadingMask = document.querySelector(".c-loading__mask");
    const loadingImg = document.querySelector(".c-loading__img");

    if (loadingMask && loadingImg && loadingContainer) {
      // スクロール位置を保存
      const scrollY = window.scrollY;
      
      // bodyとhtmlにローディングクラスを追加（背景色を適用・スクロール無効化）
      document.body.classList.add('is-loading');
      document.documentElement.classList.add('is-loading');
      document.body.style.top = `-${scrollY}px`;

      // Safariのモバイルブラウザで確実に画面全体を覆うために高さを設定
      const getViewportHeight = () => {
        // visualViewport APIが利用可能な場合はそれを使用（より正確）
        if (window.visualViewport) {
          return window.visualViewport.height;
        }
        // フォールバック: 実際の画面高さを取得
        return Math.max(window.innerHeight, document.documentElement.clientHeight);
      };

      const setFullScreenHeight = () => {
        const vh = getViewportHeight();
        // --vhは100vhに相当するピクセル値として設定
        loadingContainer.style.setProperty('--vh', `${vh}px`);
        loadingContainer.style.height = `${vh}px`;
      };
      
      setFullScreenHeight();
      
      // リサイズ時とvisualViewport変更時に高さを更新
      const handleResize = () => {
        setFullScreenHeight();
      };
      window.addEventListener('resize', handleResize);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', handleResize);
      }

      // スクロールを防ぐ
      const preventScroll = (e) => {
        e.preventDefault();
        window.scrollTo(0, scrollY);
      };
      window.addEventListener('scroll', preventScroll, { passive: false });
      window.addEventListener('touchmove', preventScroll, { passive: false });

      // 初期状態を設定
      gsap.set(loadingMask, { opacity: 1, visibility: "visible" });
      gsap.set(loadingImg, { opacity: 0, visibility: "visible", scale: 0.98 });
      gsap.set(loadingContainer, { display: "block", visibility: "visible", height: `${getViewportHeight()}px` });

      startLoadingAnimation(() => {
        // アニメーション終了時に完全に非表示
        gsap.set(loadingMask, { display: "none", visibility: "hidden" });
        gsap.set(loadingImg, { display: "none", visibility: "hidden" });
        gsap.set(loadingContainer, { display: "none", visibility: "hidden" });
        
        // bodyとhtmlからローディングクラスを削除（背景色を解除・スクロール有効化）
        document.body.classList.remove('is-loading');
        document.documentElement.classList.remove('is-loading');
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
        
        // イベントリスナーを削除
        window.removeEventListener('resize', handleResize);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', handleResize);
        }
        window.removeEventListener('scroll', preventScroll);
        window.removeEventListener('touchmove', preventScroll);
      });
    } else {
      // 要素が見つからない場合でも画面操作を可能にする
      loadingContainer.style.display = "none";
    }
  };

  // _accessリンクが押されたときの処理
  const accessLinks = document.querySelectorAll(".c-drawer__link._access");
  const drawerModal = document.querySelector(".c-drawer__modal");
  const drawerButton = document.querySelector(".js-drawerButton");

  accessLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      const href = link.getAttribute("href");
      const [url, hash] = href.split("#");
      const isCurrentPage = location.pathname === new URL(url, location.origin).pathname;
      const targetElement = hash ? document.getElementById(hash) : null;

      if (window.innerWidth <= 768) {
        handleSpNavigation(isCurrentPage, targetElement, drawerModal, drawerButton, url, hash);
      } else {
        handleNavigation(isCurrentPage, targetElement, drawerModal, drawerButton, url, hash);
      }
    });
  });

  // GSAPの読み込みを待つ処理
  const waitForGSAP = (callback, maxAttempts = 50) => {
    let attempts = 0;
    const checkGSAP = () => {
      if (typeof gsap !== "undefined") {
        callback();
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(checkGSAP, 100);
      } else {
        console.error("GSAP failed to load after waiting");
        // GSAPが読み込まれない場合でも画面操作を可能にする
        const loadingContainer = document.querySelector(".c-loading");
        if (loadingContainer) {
          loadingContainer.style.display = "none";
        }
      }
    };
    checkGSAP();
  };

  // DOMContentLoaded時に初期化を試行
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      waitForGSAP(() => {
        initializeLoadingAnimation();
      });
    });
  } else {
    // すでにDOMが読み込まれている場合
    waitForGSAP(() => {
      initializeLoadingAnimation();
    });
  }

  // ページロード時にハッシュスクロール処理を実行
  window.addEventListener("load", () => {
    const hash = window.location.hash;
    const targetId = hash ? hash.substring(1) : null;
    const targetElement = targetId ? document.getElementById(targetId) : null;

    if (targetElement) {
      // ローディング後に対象箇所へスクロール
      setTimeout(() => {
        targetElement.scrollIntoView({ behavior: "auto", block: "start" });
      }, 3300); // ローディング後
    }
  });
}

// SPサイズ専用の遷移処理
function handleSpNavigation(isCurrentPage, targetElement, drawerModal, drawerButton, url, hash) {
  closeDrawer(drawerModal, drawerButton);

  if (isCurrentPage && targetElement) {
    setTimeout(() => {
      targetElement.scrollIntoView({ behavior: "auto", block: "start" });
    }, 50);
  } else if (!isCurrentPage) {
    startLoadingAnimation(() => {
      window.location.href = `${url}#${hash}`;
    });
  }
}

// 通常の遷移処理
function handleNavigation(isCurrentPage, targetElement, drawerModal, drawerButton, url, hash) {
  closeDrawer(drawerModal, drawerButton);

  if (isCurrentPage && targetElement) {
    targetElement.scrollIntoView({ behavior: "auto", block: "start" });
  } else if (!isCurrentPage) {
    startLoadingAnimation(() => {
      window.location.href = `${url}#${hash}`;
    });
  }
}

// ドロワーを閉じる処理
function closeDrawer(drawerModal, drawerButton) {
  if (drawerModal && drawerButton) {
    drawerModal.classList.remove("is-open");
    drawerButton.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    document.body.style.touchAction = "";
  }
}

// ローディングアニメーション処理
function startLoadingAnimation(callback) {
  // GSAPが読み込まれているか確認
  if (typeof gsap === "undefined") {
    console.error("GSAP is not loaded");
    if (callback) callback();
    return;
  }

  const loadingImg = document.querySelector(".c-loading__img");
  const loadingMask = document.querySelector(".c-loading__mask");

  if (loadingImg && loadingMask) {
    const openingTL = gsap.timeline();

    openingTL
      .to(loadingImg, {
        opacity: 1,
        scale: 1,
        duration: 1,
        ease: "power2.out",
        delay: 0.5,
      })
      .to(
        loadingImg,
        {
          opacity: 0,
          duration: 0.8,
          scale: 1.1,
          filter: "blur(5px)",
        },
        "+=1"
      )
      .to(
        loadingMask,
        {
          opacity: 0,
          duration: 0.5,
        },
        "-=0.5"
      )
      .eventCallback("onComplete", callback);
  } else {
    if (callback) callback();
  }
}
